/**
 * AddressQuestion Component
 * Wrapper that handles both address-select (API lookup) and address-manual (fallback) modes
 */

import { useState } from 'react'
import AddressSelectQuestion from './AddressSelectQuestion'
import ManualAddressQuestion from './ManualAddressQuestion'

interface AddressQuestionProps {
  questionId: string
  postcode: string
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: Define union type for address value variants
  value: any
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: Define union type for address value variants
  onChange: (value: any) => void
  required?: boolean
  error?: string
}

const AddressQuestion = ({
  questionId,
  postcode,
  value,
  onChange,
  required = false,
  error
}: AddressQuestionProps) => {
  const [useManualEntry, setUseManualEntry] = useState(false)

  // If API lookup fails, switch to manual entry
  const handleManualEntryRequired = () => {
    setUseManualEntry(true)
  }

  if (useManualEntry) {
    return (
      <ManualAddressQuestion
        questionId={questionId}
        postcode={postcode}
        value={value}
        onChange={onChange}
        required={required}
        error={error}
      />
    )
  }

  return (
    <AddressSelectQuestion
      questionId={questionId}
      postcode={postcode}
      value={value}
      onChange={onChange}
      required={required}
      error={error}
      onManualEntryRequired={handleManualEntryRequired}
    />
  )
}

export default AddressQuestion
